import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { get } from 'lodash';
import BuyNowCeil from './BuyNowCeil';
import { styles } from '../../../AuctionForm/formStyles';
import { compose } from 'redux';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const BrowseCell = ({ hihestBetValue, buyNowContract, contractSent, t, }) => {
  const classes = useStyles({ buyNowContract, contractSent, });
  return (
    <div>
      <button className={`btn blue ${classes.button}`}>
        <span>{t('bets_button_cell')}</span>
      </button>
      {Boolean(hihestBetValue) &&
        <div className={classes.highestBetContainer}>
          <span className={classes.highestBet}>
            {t('highest_offer')} &nbsp;
            <span className={classes.hihestBetValue}>{hihestBetValue} &euro;</span>
          </span>
        </div>
      }
      {buyNowContract &&
        <BuyNowCeil price={get(buyNowContract, 'price')} description={t('buy_now')} />
      }
    </div>
  );
};

BrowseCell.propTypes = {
  hihestBetValue: PropTypes.number,
  t: PropTypes.func.isRequired,
  contractSent: PropTypes.bool,
  buyNowContract: PropTypes.object,
};

BrowseCell.defaultProps = {
  hihestBetValue: null,
  betsAmountLabel: '',
  buyNowContract: false,
  contractSent: false,
};

const useStyles = createUseStyles({
  highestBet: {
    fontSize: '14px',
    whiteSpace: 'nowrap',
    '& strong': {
      color: styles.colors.darkGray,
      fontSize: '15px',
    },
  },
  highestBetContainer: {
    marginRight: '8px',
  },
  bettingIcon: {
    marginRight: '5px',
    color: 'white',
  },
  hihestBetValue: (props) => ({
    fontWeight: props.contractSent ? 'bold' : 'normal',
    color: '#54515A',
  }),
});

export default compose(withScopedTranslations('tables'))(BrowseCell);

